import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import {
  RegisterCompComponent,
  RegistrationSuccessComponent,
} from "./register-comp/register-comp.component";
import { HeaderCompComponent } from "./header-comp/header-comp.component";
import { AppRoutingModule } from "./app.route";
import { VerifyCompComponent } from "./verify-comp/verify-comp.component";
import { LoginComponent } from "./login/login.component";
import { PartnerComponent } from "./partner/partner.component";
import { TabsModule } from "ngx-bootstrap/tabs";
import { OnlyNumberDirective } from "./utilComp/numberOnlyDirective";
import { OnlyNumberPasteDirective } from "./utilComp/numberWithOutPaste";
import { AppPasswordDirective } from "./utilComp/appPasswordDirective";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { SecurityPageComponent } from "./security-page/security-page.component";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "./shared/shared.module";
import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import {
  HttpClientModule,
  HttpClientJsonpModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { ProfileComponent } from "./profile/profile.component";
import { EditProfileComponent } from "./profile/edit-profile/edit-profile.component";
import { AuthGuardService, NonLoggedInState } from "./auth-guard.service";
import { NoInternetComponent } from "./modals/no-internet/no-internet.component";
import { CookieService } from "ngx-cookie-service";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { MediaManagerComponent } from "./media-manager/media-manager.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatChipsModule } from "@angular/material/chips";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { LogOutComponent } from "./log-out/log-out.component";
import { DatePipe } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgxCaptchaModule } from "ngx-captcha";
import { Router, RouterModule } from "@angular/router";
import { AuthInterceptor } from "./auth.interceptor";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { AssessmentService } from "./assessments-module/assessment.service";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { NgImageSliderModule } from "ng-image-slider";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { CommonModule } from "@angular/common";
import { NgOtpInputModule } from "ng-otp-input";

import { HeaderComponent } from "./header/header.component";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { Overlay } from "@angular/cdk/overlay";

@NgModule({
  declarations: [
    AppComponent,
    RegistrationSuccessComponent,
    LoginComponent,
    VerifyCompComponent,
    OnlyNumberDirective,
    OnlyNumberPasteDirective,
    AppPasswordDirective,
    DashboardComponent,
    PartnerComponent,
    SecurityPageComponent,
    ProfileComponent,
    EditProfileComponent,
    NoInternetComponent,
    PrivacyPolicyComponent,
    MediaManagerComponent,
    ForgotPasswordComponent,
    LogOutComponent,
    HeaderCompComponent,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    HeaderComponent,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    CommonModule,
    NgOtpInputModule,
    RouterModule,

    // Working third-party modules
    TabsModule.forRoot(),
    NgxCaptchaModule,
    NgxUiLoaderModule,
    AngularEditorModule,
    LoadingBarModule,
    LoadingBarHttpClientModule,
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
    }),

    // Angular Material modules
    MatProgressBarModule,
    MatTabsModule,
    MatChipsModule,
    MatIconModule,
    MatSlideToggleModule,
    NgImageSliderModule,
    HeaderComponent,
  ],
  providers: [
    AuthGuardService,
    NonLoggedInState,
    CookieService,
    AssessmentService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: function (router: Router) {
        return new AuthInterceptor(router);
      },
      multi: true,
      deps: [Router],
    },
    // {
    //   provide: MAT_DIALOG_DEFAULT_OPTIONS,
    //   useFactory: (overlay: Overlay) => ({
    //     autoFocus: false,
    //     restoreFocus: false,
    //     scrollStrategy: overlay.scrollStrategies.reposition(), // ✅ GLOBAL
    //   }),
    //   deps: [Overlay],
    // },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
